export { default as PermissionMatrix } from './PermissionMatrix';
export type { PermissionMatrixProps } from './PermissionMatrix';
